// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { set } from '../../actions/betFilter';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';

import BetFilters from './BetFilters';
import selectBetFiltersProps from './BetFilters.selector';

type BetFiltersContainerProps = {
  className?: string;
};

const BetFiltersContainer = (ownProps: BetFiltersContainerProps) => {
  const params = useParams();
  const { sportId, categoryId, tournamentId } = params ?? {};

  const selectorProps = useMemo(
    () => ({
      sportId,
      categoryId,
      tournamentId,
    }),
    [sportId, categoryId, tournamentId],
  );

  const selectedProps = useSelector((state) => selectBetFiltersProps(state, selectorProps));

  const actions = useMemo(
    () => ({
      setFilter: (betFilterId) => set(betFilterId),
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return <BetFilters {...enhancedProps} />;
};

export default BetFiltersContainer;
